import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { postStartCharging } from '../../services/chargerStationService';
import ChargerStationCard from '../chargerStationCard/ChargerStationCard';
import './ChargerStationCardList.css';
import ToastStartCharging from './ToastStartCharging/ToastStartCharging';

import qrCode from '../../assets/qr_code.svg';
import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';
import { useToast } from '../../context/ToastModalContext';
import ToastChargerUnavailable from './ToastChargerUnavailable/ToastChargerUnavailable';
import ToastNoCredit from './ToastNoCredit/ToastNoCredit';
import Modal from '../../components/modal/Modal';
import { useCouponStore } from '../../hooks/useCouponStore';
import { useToastStore } from '../../hooks/useToastStore';

type ChargerStationCardListProps = {
  chargers: any[];
  siteData: any;
};

const ChargerStationCardList: React.FC<ChargerStationCardListProps> = ({
  chargers,
  siteData,
}) => {
  const { showToast } = useToast();
  const [selectedVehicle, setSelectedVehicle] = useState<string>();
  const { selectedCoupon, setSelectedCoupon } = useCouponStore();
  const { setCouponData } = useCouponStore();
  const [selectedCharger, setSelectedCharger] = useState<any>([]);

  const {
    showStartTransactionToast,
    setShowStartTransactionToast,
    showNoCreditToast,
    setShowNoCreditToast,
    showChargerUnavailableToast,
    setShowChargerUnavailableToast,
  } = useToastStore();

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useAuth();
  const brandContext = useBrandContext();

  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [titleErrorModal, setTitleErrorModal] = useState<string>('');
  const [textErrorModal, setTextErrorModal] = useState<string>('');

  const routePaths = location.pathname.split('/');

  const handleInfoChargePage = () => {
    navigate(
      `/${routePaths[1]}/recharge/${selectedCharger?.chargePointId}/${selectedCharger?.connectorId}`,
      { state: { rechargeInfos: selectedCharger, siteData: siteData } }
    );
  };

  const startCharging = async () => {
    setIsLoading(true);
    try {
      const response = await postStartCharging(
        selectedCharger?.chargePointId,
        selectedCharger?.connectorId,
        selectedVehicle,
        selectedCoupon && selectedCoupon.trim() !== '' ? selectedCoupon : null
      );
      if (response.status === 'Error') {
        setTitleErrorModal('Erro ao utilizar o cupom');
        setTextErrorModal(response.info);
        setShowErrorModal(true);
        setIsLoading(false);
        setSelectedCoupon(null);
        setCouponData({});
        return;
      }
      if (response.status === 'Accepted') {
        handleInfoChargePage();
        setIsLoading(false);
        setShowChargerUnavailableToast(false);
        setShowStartTransactionToast(false);
        setShowNoCreditToast(false);
      } else if (
        response.status === 'Rejected' &&
        response.info === 'ERR_WALLET_LOW_BALANCE'
      ) {
        setShowStartTransactionToast(false);
        setShowChargerUnavailableToast(false);
        setIsLoading(false);
        setShowNoCreditToast(true);
        setSelectedCoupon(null);
        setCouponData({});
      } else if (response.status === 'TimedOut') {
        setShowStartTransactionToast(false);
        setShowChargerUnavailableToast(true);
        setIsLoading(false);
        setShowNoCreditToast(false);
        setSelectedCoupon(null);
        setCouponData({});
      } else {
        setShowStartTransactionToast(false);
        setShowChargerUnavailableToast(true);
        setIsLoading(false);
        setShowNoCreditToast(false);
        setSelectedCoupon(null);
        setCouponData({});
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Erro ao iniciar recarga', error);
    }
  };

  const openCam = () => {
    if (authContext.user) {
      navigate(`/${brandContext.brandName}/qrcode`);
    } else {
      showToast({
        title: `Faça Login`,
        messageModal: `Faça login para usar QR code`,
        textEnterButton: 'Ir para login',
        allowButtonClosed: true,
        handleEnterButton: () => navigate(`/${brandContext.brandName}/login`),
        closeButtonText: 'Fechar',
      });
    }
  };

  return (
    <>
      <div
        className='charger-list'
        style={{
          overflow:
            showStartTransactionToast ||
            showNoCreditToast ||
            showChargerUnavailableToast ||
            showErrorModal
              ? 'hidden'
              : 'unset',
        }}
      >
        {chargers.map((charger, index) => (
          <ChargerStationCard
            key={index}
            charger={charger}
            isSelected={selectedCharger.chargePointId === charger.chargePointId}
            onClick={() => {
              setSelectedCharger(charger);
              setShowStartTransactionToast(true);
            }}
          />
        ))}

        <button className='qrcode' onClick={openCam}>
          <span>Inicie por QR Code</span>
          <img alt='qrCode-icon' src={qrCode} />
        </button>
      </div>

      <ToastStartCharging
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        chargerData={selectedCharger?.priceProfilePeriod}
        allowButtonClosed={true}
        handleStartCharging={startCharging}
        isModalOpen={showStartTransactionToast}
        setIsModalOpen={setShowStartTransactionToast}
        chargerId={selectedCharger.chargePointId}
        chargerSiteId={selectedCharger.cpCsId}
        chargerSiteName={siteData.name}
        setSelectedVehicle={setSelectedVehicle}
        selectedVehicle={selectedVehicle}
      />
      <ToastNoCredit
        isLoading={isLoading}
        allowButtonClosed={true}
        handleClick={() => navigate(`/${routePaths[1]}/paymentMethods`)}
        isModalOpen={showNoCreditToast}
        setIsModalOpen={setShowNoCreditToast}
      />
      <ToastChargerUnavailable
        onClose={() => setShowChargerUnavailableToast(false)}
        isLoading={isLoading}
        allowButtonClosed={true}
        handleStartCharging={startCharging}
        isModalOpen={showChargerUnavailableToast}
        setIsModalOpen={setShowChargerUnavailableToast}
      />
      <div
        style={{ position: 'relative', zIndex: showErrorModal ? '99999' : 0 }}
      >
        <Modal
          allowButtonClosed={false}
          isOpen={showErrorModal}
          onClose={() => setShowErrorModal(false)}
          title={titleErrorModal}
          styleEnterButton={{
            backgroundColor: 'rgb(173, 173, 173)',
            border: 'none',
          }}
          textEnterButton='Fechar'
          handleEnterButton={() => setShowErrorModal(false)}
          isLoadingEnterButton={isLoading}
        >
          <p>{textErrorModal}</p>
        </Modal>
      </div>
    </>
  );
};

export default ChargerStationCardList;
